<template>
  <div class="gray-bg">
    <div id="page-wrapper" class="row">
      <!--<div class="animated fadeInRight">-->
      <div class="animated fadeInRight ">
        <HeaderBase></HeaderBase>
        <div class="wrapper wrapper-content">
          <router-view class=" "></router-view>
        </div>
      </div>
    </div>
    <!--<MyFooter></MyFooter>-->
  </div>
</template>

<!--// 大阪・奈良・京都・兵庫-->
<style src="@/assets/css/bootstrap.min.css"></style>
<style src="@/assets/font-awesome/css/font-awesome.css"></style>
<style src="@/assets/css/animate.css"></style>
<style src="@/assets/css/style.css"></style>
<style lang="sass">
  @import "./assets/css/base.scss"
</style>
<!-- PluginいろいろあるけどjQuery依存なので封印 -->
<!--<script src="@/assets/js/jquery-2.1.1.js"></script>-->
<!--<script src="@/assets/js/bootstrap.min.js"></script>-->
<!--<script src="@/assets/js/plugins/metisMenu/jquery.metisMenu.js"></script>-->
<!--<script src="@/assets/js/plugins/slimscroll/jquery.slimscroll.min.js"></script>-->
<!---->
<!--Custom and plugin javascript-->
<!--<script src="/static/js/inspinia.js"></script>-->
<!--<script src="/static/js/plugins/pace/pace.min.js"></script>-->

<script>
  import MyHeader from './Header.vue'
  import MyFooter from '@/Footer.vue'
  import HeaderBase from '@/components/header/Base.vue'
  import SideMenu from '@/components/SideMenu.vue'
  import Api from '@/service/Api.vue'
  import WebStorage from '@/service/WebStorage.vue'

  export default {
    name: 'app',
    components: {
      SideMenu,
      HeaderBase,
      MyHeader,
      MyFooter
    },
    data: function () {
      return {}
    },
    created: function () {
      this.$store.commit('updateScope')
    },
    methods: {
      init: async function () {
        WebStorage.async.prefectures()
      }
    },
    beforeRouteUpdate (to, from, next) {
      console.log('認証成功')
      Api.token().then(function () {
        next()
      }).catch(function () {
        location.href = '/'
      })
    }
  }
</script>




// WEBPACK FOOTER //
// Layout.vue?47bedc20